import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'


import {
  selectLoginData,
  refreshTokenAsyncDocPanel,
 } from './loginSlice';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position:'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props)=> {
  const { children,classes, onClose,...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}
      </Typography>
    </MuiDialogTitle>
  )
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding:theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root:{
    margin:0,
    padding:theme.spacing(1)
,  }
}))(MuiDialogActions);




export const LogOutWarning = () => {
  let { jwt }  = useSelector(selectLoginData);
  const dispatch = useDispatch();
  const [open] = React.useState(true);

  return (
    <div>
      <Dialog aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id = "customized-dialog-title">
          Do you want to stay logged in?
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            You have been inactive for quite a while. Please let us know we should keep you logged in
            or we will auto log you out for your safety.
            Thank you
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button id="logonButton" variant="contained" color="primary" onClick={() => dispatch(refreshTokenAsyncDocPanel(jwt))}>
          I'm still here
          </Button>
        </DialogActions>
        </Dialog>
    </div>
  
  );
}
